import { __assign, __extends } from "tslib";
import * as React from 'react';
var Stepper = /** @class */ (function (_super) {
    __extends(Stepper, _super);
    function Stepper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Stepper.prototype.getStepProps = function () {
        var _this = this;
        return function (stepIndex, overrides) {
            if (overrides === void 0) { overrides = {}; }
            return (__assign({ active: _this.props.activeStep === stepIndex, visited: _this.props.activeStep > stepIndex }, overrides));
        };
    };
    Stepper.prototype.render = function () {
        var children = this.props.children;
        return children({ getStepProps: this.getStepProps() });
    };
    return Stepper;
}(React.PureComponent));
export { Stepper };
//# sourceMappingURL=Stepper.js.map